"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onlyAlphaNumeric = void 0;

/**
 * remove all non alphaNumeric characters from a string
 * also convert it to lower case
 * @param {string} nameString - string that you want to work on
 * @return {string}
 */
var onlyAlphaNumeric = function onlyAlphaNumeric(nameString) {
  var allow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var re = new RegExp("[^".concat(allow, "a-zA-Z0-9]"), 'g');
  return nameString.replace(re, '').toLowerCase();
};

exports.onlyAlphaNumeric = onlyAlphaNumeric;